import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";

import { db } from '../../firebase'









function Gallery() {
    const [setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showPerPage, setShowPerPage] = useState(58);
    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage,
    });

    const onPaginationChange = (start, end) => {
        setPagination({ start: start, end: end });
    };
    const [searchTerm, setsearchTerm] = useState("");
    const [programs, setPrograms] = useState([])
    const navigate = useNavigate()

    const programsCollectionRef = collection(db, "GALLERY");
    useEffect(() => {

        const getPrograms = async () => {
            const data = await getDocs(programsCollectionRef);
            setPrograms(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }

        getPrograms()
    }, [])
    return (

        <>

            <div className="album py-0">

                <div className="container">

                    <div className="row">
                        {programs.filter((val) => {
                            if (setsearchTerm === "") {
                                return val;
                            } else if (
                                val.title.toLowerCase().includes(searchTerm.toLowerCase())




                            ) {
                                return val;
                            }
                        }).slice(pagination.start, pagination.end).map((thehopingsunexim) => {
                            return (
                                <div className="col-md-4 mt-3">
                                    <div className='hoverimage1'>
                                        <img className="card-img-top image2" src={thehopingsunexim.img} alt={thehopingsunexim.title} />
                                        <div className="overlay1"> {thehopingsunexim.title}</div>
                                    </div>
                                    <div className="card-body">
                                        <center>
                                        </center>
                                        <div className="d-flex justify-content-between align-items-center">
                                        </div>
                                    </div>


                                </div>
                            )
                        })}
                    </div>


                </div>
            </div>

        </>

    );
}

export default Gallery;



